import React, {useEffect, useRef, useState} from "react";
import MediaPlayer from "../MediaPlayer";
import {makeStyles, Theme, useTheme} from "@material-ui/core/styles";
import {useSelector} from "react-redux";
import {RootState} from "../../redux/store";
import {Box, Button, Dialog, IconButton, Menu, MenuItem, Select, Typography, useMediaQuery} from "@material-ui/core";
import VideocamOffIcon from "@material-ui/icons/VideocamOff";
import VideocamIcon from "@material-ui/icons/Videocam";
import VolumeMuteIcon from "@material-ui/icons/VolumeMute";
import VolumeUpIcon from "@material-ui/icons/VolumeUp";
import PhoneDisabledIcon from "@material-ui/icons/PhoneDisabled";
import {useHistory} from "react-router";
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
import SoundAndCameraCheck from "./SoundAndCameraCheck";
import {setCookie} from "../../helpers/cookieHelpers";
import ChatBubbleIcon from "@material-ui/icons/ChatBubble";
import FullscreenIcon from "@material-ui/icons/Fullscreen";
import FullscreenExitIcon from "@material-ui/icons/FullscreenExit";
import {IAgoraRTCRemoteUser, ICameraVideoTrack, IMicrophoneAudioTrack} from "agora-rtc-sdk-ng";

const useStyle = makeStyles((theme: Theme) => ({
    roomContainer: {
        maxHeight: 540,
    },
    buttonContainer: {
        marginTop: 30,
        display: "flex",
        justifyContent: "center",
        [theme.breakpoints.down("xs")]: {
            position: "fixed",
            bottom: 5,
            width: "50%",
            justifyContent: "left",
        }
    },
    buttons: {
        display: "flex",
        paddingY: "16px",
        flexDirection: "row",
        position: "relative",
        justifyContent: "space-around",
        width: "100%",
        [theme.breakpoints.down("xs")]: {
            width: "50%",
            flexDirection: "column",
            justifyContent: "left",
        }
    },
    buttonClassLogout: {
        marginLeft: 10,
        backgroundColor: "red"
    },
    settingsIcon: {
        display: "flex",
        alignItems: "center",
        cursor: "pointer",
        paddingLeft: "10px"
    },
    myVideoContainer: {
        width: 200,
        position: "absolute",
        right: "10%",
        zIndex: 100,
        height: 150,
        backgroundColor: "#000",
        [theme.breakpoints.down("xs")]: {
            backgroundColor: "unset",
        }
    },
    incomminVideoContainer: {
        position: "relative",
        display: "flex",
        justifyContent: "center",
        minWidth: 320,
        minHeight: 240,
        // maxWidth: 600,
        // maxHeight: 480,
        width: "50%",
        height: "auto",
        margin: "20px auto 0",
        backgroundColor: "#000",
        [theme.breakpoints.down("xs")]: {
            position: "fixed",
            width: "100%",
            maxHeight: "80%",
            height: "60%",
            top: "80px",
            margin: 0,
        }
    },
    incomminTestVideoContainer: {
        [theme.breakpoints.down("xs")]: {
            position: "unset",
            width: "100%",
            maxHeight: "80%",
            height: "60%",
            margin: 0,
        },
        width: "unset",
    }
}));

const vetStyle = makeStyles((theme: Theme) => ({
    buttonContainer: {
        marginTop: 10,
        marginBottom: 10,
        display: "flex",
        justifyContent: "center",
    },
    buttons: {
        display: "flex",
        paddingY: "16px",
        flexDirection: "row",
        bgcolor: "#fff",
        justifyContent: "space-around",
        width: "100%",
    },
    buttonClassLogout: {
        marginLeft: 10,
        backgroundColor: "red"
    },
    settingsIcon: {
        display: "flex",
        alignItems: "center",
        cursor: "pointer",
        paddingLeft: "10px"
    },
    myVideoContainer: {
        width: 200,
        position: "absolute",
        zIndex: 100,
        top: "11.25%",
        backgroundColor: "#000",
        [theme.breakpoints.down("xs")]: {
            top: "5vh",
        }
    },

    incomminVideoContainer: {
        position: "relative",
        display: "flex",
        justifyContent: "center",
        minWidth: 330,
        width: "100%",
        minHeight: 330,
        height: "auto",
        marginTop: "11.25%",
        maxHeight: "calc(100vh - 100px)",
        margin: "auto",
        backgroundColor: "#000",
        [theme.breakpoints.down("sm")]: {
            position: "relative",
            width: "100%",
            height: "auto",
            // transform: "translateX(-50%)",
            margin: 0,
        }
    },
}));

interface IAgoraService {
    localAudioTrack: IMicrophoneAudioTrack | undefined,
    localVideoTrack: ICameraVideoTrack | undefined,
    joinState: boolean,
    leave: Function,
    join: Function,
    remoteUsers: IAgoraRTCRemoteUser[],
    audioDevices: object[] | any,
    videoDevices: object[] | any,
    audioDevice: object | any,
    videoDevice: object | any,
    updateAudioInput: (string) => void,
    updateVideoInput: (string) => void,
}

interface CallProps {
    agoraService: IAgoraService,
    handleLogout: () => void,
    showCheckArr: any,
    setDisplayChat: (boolean) => void,
    token: string,
    channel: string,
    identity?: number,
}

const Call: React.FC<CallProps> = (
    {
        agoraService,
        handleLogout,
        showCheckArr,
        setDisplayChat,
        token,
        channel,
        identity
    }) => {
    const [showCheck, setShowCheck] = showCheckArr;
    const [video, setVideo] = useState(true);
    const [audio, setAudio] = useState(true);
    const [fullscreen, setFullscreen] = useState(false);
    const user = useSelector((state: RootState) => state?.user);
    const isVet = user.role === "VET";
    const classes = useStyle();
    const vetClasses = vetStyle();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("xs"));
    const appid = process.env.REACT_APP_AGORA_APP_ID;
    const {
        localAudioTrack,
        localVideoTrack,
        joinState,
        leave,
        join,
        remoteUsers,
        audioDevices,
        videoDevices,
        audioDevice,
        videoDevice,
        updateAudioInput,
        updateVideoInput,
    } = agoraService;
    const aloneInRoom = !remoteUsers?.length;
    const ref = useRef(null);

    useEffect(() => {
        if (showCheck === false) {
            join(process.env.REACT_APP_AGORA_APP_ID, channel, token, identity);
        }
    }, [showCheck]);

    useEffect(() => {
        if (localVideoTrack) {
            if (!video) {
                localVideoTrack.setMuted(true);
            } else {
                localVideoTrack.setMuted(false);
            }
        }

    }, [video]);

    useEffect(() => {
        if (localAudioTrack) {
            if (!audio) {
                localAudioTrack.setMuted(true);
            } else {
                localAudioTrack.setMuted(false);
            }
        }
    }, [audio]);

    const startChat = (audioDevice, videoDevice) => {
        setShowCheck(false);
        setCookie("room",
            JSON.stringify({
                video: videoDevice,
                audio: audioDevice,
            }),
            null);
        setCookie("visited", "yes", null);
    };

    useEffect(() => {
        if (typeof joinState === "boolean" && !isVet && (aloneInRoom || remoteUsers.length)) {
            let videoHeight = `${ref.current.clientHeight}px`;
            document.querySelector(".video-chat-container")?.setAttribute("style", `height: calc(100vh - ${videoHeight || "300px"} - 145px)`);
        }
    }, [joinState, remoteUsers]);

    const call = <div className="call">
        {
            showCheck
            &&
            <SoundAndCameraCheck
                startChat={startChat}
            />
        }
        <div className="player-container">
            <SettingsMenu
                audioInputDevices={audioDevices}
                audioInput={audioDevice}
                setAudioInput={updateAudioInput}
            />
            <div id="video-container" ref={ref}>
                <div
                    className={`${!aloneInRoom ? (isVet ? vetClasses.myVideoContainer : classes.myVideoContainer) : (isVet ? vetClasses.incomminVideoContainer : classes.incomminVideoContainer)} `}
                >
                    <MediaPlayer
                        videoTrack={localVideoTrack}
                        audioTrack={undefined}
                        isVet={isVet}
                        aloneInRoom={aloneInRoom}
                        fullscreen={isVet && fullscreen}
                        ownVideo={true}
                    />
                </div>
                {remoteUsers.map(user => (
                    <div
                        className={`${isVet ? vetClasses.incomminVideoContainer : classes.incomminVideoContainer} `}
                        key={user.uid}
                    >
                        <MediaPlayer
                            videoTrack={user.videoTrack}
                            audioTrack={user.audioTrack}
                            isVet={isVet}
                            aloneInRoom={false}
                            ownVideo={false}
                        />
                    </div>))}
            </div>
            <Box className={isVet ? vetClasses.buttonContainer : classes.buttonContainer}>
                <Box className={isVet ? vetClasses.buttons : classes.buttons}>
                    {isMobile && !isVet
                    &&
                    <IconButton
                        style={{marginRight: 5}}
                        onClick={() => {
                            setDisplayChat(true);
                        }}
                    >
                        <Box
                            display="flex"
                            flexDirection="column"
                            alignContent="center"
                        >
                            <ChatBubbleIcon
                                fontSize="small"
                                color="secondary"
                                style={{color: "#273878", alignSelf: "center"}}
                            />
                            <span style={{fontSize: 10}}>Open Chat</span>
                        </Box>
                    </IconButton>
                    }
                    <IconButton style={{marginRight: 5}} onClick={() => {
                        setVideo(!video);
                    }}>
                        {video ?
                            <Box display="flex" flexDirection="column" alignContent="center">
                                <VideocamOffIcon fontSize="small"
                                    style={{color: "#273878", alignSelf: "center"}}/>
                                <span style={{fontSize: 10}}>Hide Camera</span>
                            </Box> :
                            <Box display="flex" flexDirection="column" alignContent="center">
                                <VideocamIcon fontSize="small" color="secondary"
                                    style={{alignSelf: "center"}}/>
                                <span style={{fontSize: 10}}>Display Camera</span>
                            </Box>}
                    </IconButton>
                    <IconButton style={{marginRight: 5}} onClick={() => {
                        setAudio(!audio);
                    }}>
                        {audio ?
                            <Box display="flex" flexDirection="column" alignContent="center">
                                <VolumeMuteIcon fontSize="small"
                                    style={{color: "#273878", alignSelf: "center"}}/>
                                <span style={{fontSize: 10}}>Mute</span>
                            </Box>
                            :
                            <Box display="flex" flexDirection="column" alignContent="center">
                                <VolumeUpIcon fontSize="small" color="secondary"
                                    style={{alignSelf: "center"}}/>
                                <span style={{fontSize: 10,}}> Un-Mute</span>
                            </Box>}
                    </IconButton>
                    {isVet
                    &&
                    <IconButton style={{marginRight: 5}} onClick={() => {
                        setFullscreen(prev => !prev);
                    }}>
                        {fullscreen ?
                            <Box display="flex" flexDirection="column" alignContent="center">
                                <FullscreenExitIcon
                                    fontSize="small"
                                    color="secondary"
                                    style={{alignSelf: "center"}}
                                />
                                <span style={{fontSize: 10}}>Exit Fullscreen</span>
                            </Box>
                            :
                            <Box display="flex" flexDirection="column" alignContent="center">
                                <FullscreenIcon
                                    fontSize="small"
                                    style={{color: "#273878", alignSelf: "center"}}
                                />
                                <span style={{fontSize: 10,}}>Fullscreen</span>
                            </Box>}
                    </IconButton>
                    }
                    {!isVet ? (
                        <IconButton style={{marginRight: 5}} onClick={handleLogout}>
                        <Box display="flex" flexDirection="column" alignContent="center">
                            <PhoneDisabledIcon fontSize="small"
                                style={{color: "red", alignSelf: "center"}}/>
                            <span style={{fontSize: 10}}>Leave Video</span>
                        </Box>
                        </IconButton>
                    ) : ""}
                </Box>
                {(!isVet
                    &&
                    (document.getElementsByClassName("intercom-lightweight-app").length > 0
                    ||
                    document.getElementsByClassName("intercom-app").length > 0))
                    &&
                <Typography
                    style={{
                        position: "fixed",
                        bottom: 75,
                        right: 100,
                        zIndex: 20000,
                    }}>Contact
                    Support:</Typography>}
            </Box>
        </div>
    </div>;

    return (
        <>
            {isVet && fullscreen ?
                < Dialog
                    fullScreen
                    open
                >
                    {call}
                </Dialog>
                :
                call
            }
        </>
    );
};

export default Call;

const SettingsMenu = ({audioInputDevices, audioInput, setAudioInput}) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const history = useHistory();
    const classes = useStyle();

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = (url) => {
        history.push(url);
        setAnchorEl(null);
    };

    return (
        <Box
            style={{
                paddingLeft: "10px",
                marginTop: "50px"
            }}
        >
            {audioInputDevices.length ?
                <Box>
                    <Box aria-controls="simple-menu" aria-haspopup="true" onClick={handleClick}
                        className={classes.settingsIcon}>
                        <MoreHorizIcon color="primary"/>
                    </Box>
                    <Menu
                        id="simple-menu"
                        anchorEl={anchorEl}
                        keepMounted
                        open={Boolean(anchorEl)}
                        onClose={handleClose}
                        getContentAnchorEl={null}
                        anchorOrigin={{
                            vertical: "bottom",
                            horizontal: "left",
                        }}
                        transformOrigin={{
                            vertical: "top",
                            horizontal: "left",
                        }}
                    >
                        <Box
                            display="flex"
                            flexDirection="column"
                            justifyContent="space-between"
                            style={{padding: "20px 10px"}}
                        >
                            <Box display="flex" flexDirection="column" marginBottom="15px">
                                <Typography color="textSecondary">Microphone</Typography>
                                <Select
                                    label="Microphone"
                                    placeholder="Microphone"
                                    value={audioInput}
                                    margin="dense"
                                    onChange={(event) => setAudioInput(event.target.value)}
                                >
                                    {
                                        audioInputDevices.map((item, idx) => (
                                            <MenuItem key={idx} value={item.deviceId}>{item.label}</MenuItem>))
                                    }
                                </Select>
                            </Box>
                        </Box>
                    </Menu>
                </Box> : null
            }
        </Box>
    );
};

